import React, { createContext, useContext, useEffect, useState } from "react";
import { getAPI } from "../utils/common";
import { APP_PAGE_LIST } from "../constants/api";

const AppPageContext = createContext();

export const AppPageProvider = ({ children }) => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAPI(
      APP_PAGE_LIST,
      (res) => {
        if (res.status) {
          setPages(res.data);
        }
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, []);

  const isRouteEnabled = (route) => {
    const page = pages.find((p) => p.route === route);
    return page ? page.is_enabled : true; // default allow
  };

  return (
    <AppPageContext.Provider value={{ pages, loading, isRouteEnabled }}>
      {children}
    </AppPageContext.Provider>
  );
};

export const useAppPages = () => useContext(AppPageContext);
